export default __webpack_public_path__ + "static/media/chat.5b52746b.svg";